<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="calcWidth"
    :height="calcHeigth"
    viewBox="0 0 22 22"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11zm0-1.877a9.123 9.123 0 1 0 0-18.246 9.123 9.123 0 0 0 0 18.246z"
      />
      <circle cx="11" cy="7" r="1" />
      <path d="M11 9c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1s1-.4 1-1v-5c0-.6-.4-1-1-1z" />
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      color: {
        default: '#F1CB1C',
        type: String
      },
      size: {
        default: '',
        type: String
      },
      height: {
        default: '',
        type: String
      },
      width: {
        default: '',
        type: String
      }
    },
    computed: {
      calcWidth() {
        return this.size || this.width || '23';
      },
      calcHeigth() {
        return this.size || this.heigth || '23';
      }
    }
  };
</script>
